import { SxProps, Theme } from "@mui/material";
import { red } from "@mui/material/colors";

export type PushingTugPlanningStyles = {
	readonly header: SxProps<Theme>;
	readonly sidebar: SxProps<Theme>;
	readonly voyageItem: (selected: boolean, hasErrors: boolean) => SxProps<Theme>;
	readonly droppableZone: (active: boolean) => SxProps<Theme>;
	readonly callInformation: (dragging: boolean, isStatic: boolean) => SxProps<Theme>;
	readonly dialogStyling: { content: SxProps<Theme> };
	readonly loadingBox: SxProps<Theme>;
	readonly formStyle: React.CSSProperties;
	readonly voyageItemContentBox: SxProps<Theme>;
	readonly contentBox: SxProps<Theme>;
	readonly callLinkRowBox: SxProps<Theme>;
	readonly draggableBox: SxProps<Theme>;
	readonly emptyDroppableText: SxProps<Theme>;
	readonly callInfoTitleBox: SxProps<Theme>;
	readonly callInfoDateBox: SxProps<Theme>;
};

export const styles: PushingTugPlanningStyles = {
	header: {
		display: "flex",
		alignItems: "center",
		gap: 1,
	},
	sidebar: {
		width: 280,
		borderRight: "1px solid",
		borderColor: "grey.200",
		p: 2,
		backgroundColor: "grey.50",
	},
	voyageItem: (selected: boolean, hasErrors: boolean) => ({
		flexDirection: "column",
		alignItems: "flex-start",
		border: "1px solid",
		borderColor: selected ? "primary.main" : hasErrors ? "error.main" : "grey.300",
		borderRadius: 2,
		mb: 1,
		p: 1,
		backgroundColor: hasErrors ? red[100] : "background.paper",
		"&:hover": {
			borderColor: "primary.main",
			backgroundColor: hasErrors ? red[200] + "99" : "background.paper",
		},
		"&.Mui-selected": hasErrors
			? {
				borderColor: "error.main",
				backgroundColor: red[200] + "CC",
			}
			: undefined,
		"&.Mui-selected:hover": hasErrors
			? {
				backgroundColor: red[200] + "FF",
			}
			: undefined,
	}),
	droppableZone: (active: boolean) => ({
		flex: 1,
		minHeight: 45,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		outline: active ? "2px dashed" : "1px dashed",
		outlineColor: active ? "primary.main" : "grey.400",
		outlineOffset: -1,
		backgroundColor: active ? "primary.50" : "transparent",
		borderRadius: 2,
		alignSelf: "stretch",
		boxSizing: "border-box",
		transition: "all 0.25s ease",
		":has(.pushed-barge-call):not(:has(.dragging))": {
			outline: "inherit",
		},
	}),
	callInformation: (dragging: boolean, isStatic: boolean) => ({
		flex: 1,
		p: 1.5,
		borderRadius: 2,
		minHeight: 45,
		backgroundColor: isStatic ? "grey.100" : dragging ? "primary.light" : "background.paper",
		border: "1px solid",
		borderColor: dragging ? "primary.main" : "grey.300",
		boxShadow: dragging ? 6 : 1,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		gap: 0.75,
		transition: "all 0.25s ease",
		"&:hover": isStatic
			? undefined
			: {
				backgroundColor: "grey.50",
				boxShadow: 3,
				borderColor: "primary.main",
			},
	}),
	dialogStyling: {
		content: { padding: 0 },
	},
	loadingBox: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		minHeight: 40,
	},
	formStyle: {
		display: "flex",
	},
	voyageItemContentBox: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 1,
		width: "100%",
	},
	contentBox: {
		flex: 1,
		p: 3,
	},
	callLinkRowBox: {
		display: "flex",
		alignItems: "center",
		gap: 2,
		mb: 2,
	},
	draggableBox: {
		flex: 1,
	},
	emptyDroppableText: {
		padding: 1,
	},
	callInfoTitleBox: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
	callInfoDateBox: {
		display: "flex",
		gap: 3,
	},
};
